import { render, staticRenderFns } from "./scbjgz.vue?vue&type=template&id=a3ea9152&scoped=true&"
import script from "./scbjgz.vue?vue&type=script&lang=js&"
export * from "./scbjgz.vue?vue&type=script&lang=js&"
import style0 from "./scbjgz.vue?vue&type=style&index=0&id=a3ea9152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ea9152",
  null
  
)

export default component.exports